<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
      :before-close="handleClose"
    >
      <div class="form-center" v-loading.fullscreen.lock="loading">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="生成详情" name="1">
            <div>
              <el-button
                type="primary"
                @click="startExecution"
                :disabled="State == 1"
                v-if="DevData.some((item) => item.TaskPlanDetailStatus == 0)"
                >{{
                  State == 0
                    ? '开始生成'
                    : State == 1
                    ? '生成中'
                    : State == 2
                    ? '继续生成'
                    : ''
                }}</el-button
              >
              <el-button
                type="primary"
                @click="suspend"
                v-if="
                  DevData.some((item) => item.TaskPlanDetailStatus == 0) &&
                  State != 2
                "
                >暂停</el-button
              >
              <el-input
                v-model="DeviceName"
                clearable
                placeholder="请输入设备名称/编号"
                style="width: 300px; margin-left: 10px"
              ></el-input>
              <el-button
                type="primary"
                @click="handleSearch"
                style="margin-left: 10px"
                >查询</el-button
              >
              <div style="float: right">
                <el-tag type="info" size="medium "
                  ><span style="color: #67c23a"> 生成完成 {{ numTo }}</span> /
                  <span style="color: #f56c6c"
                    >{{ DevData.length - numTo }} 未生成</span
                  ></el-tag
                >
              </div>
            </div>
            <el-table
              :data="DevData"
              ref="DevData"
              style="width: 100%"
              :row-class-name="rowclassname"
            >
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>
              <el-table-column
                label="设备编号"
                align="center"
                prop="DeviceCode"
              >
              </el-table-column>
              <el-table-column
                label="设备名称"
                align="center"
                prop="device_name"
              >
              </el-table-column>
              <el-table-column
                label="设备型号"
                align="center"
                prop="model_number"
              >
              </el-table-column>
              <el-table-column
                label="设备规格"
                align="center"
                prop="specification"
              >
              </el-table-column>

              <el-table-column
                label="安装位置"
                align="center"
                prop="InstallationAreaName"
              >
              </el-table-column>
              <el-table-column label="生成状态" align="center" prop="State">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.TaskPlanDetailStatus == 0"
                    type="danger"
                    >未生成</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.TaskPlanDetailStatus == 1"
                    >生成完成</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="生成进度"
                align="center"
                prop="loadingNum"
                width="300px"
              >
                <template slot-scope="scope">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="20"
                    :percentage="scope.row.loadingNum"
                  ></el-progress>
                  <span v-if="scope.row.loading"
                    >已用时{{ scope.row.loadingmm }}秒</span
                  >
                </template>
              </el-table-column>

              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="openList(scope.row)"
                    v-if="scope.row.TaskPlanDetailStatus == 1"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="计划详情" name="2">
            <el-collapse v-model="collapseNames">
              <el-collapse-item title="1.设备信息" name="1">
                <el-table
                  :data="dataInfo.device_TaskPlanDetails"
                  ref="DevData"
                  style="width: 100%"
                >
                  <el-table-column label="序号" width="50" type="index">
                  </el-table-column>

                  <el-table-column
                    label="设备编号"
                    align="center"
                    prop="DeviceCode"
                  >
                  </el-table-column>
                  <el-table-column
                    label="设备名称"
                    align="center"
                    prop="device_name"
                  >
                  </el-table-column>
                  <el-table-column
                    label="设备型号"
                    align="center"
                    prop="model_number"
                  >
                  </el-table-column>
                  <el-table-column
                    label="设备规格"
                    align="center"
                    prop="specification"
                  >
                  </el-table-column>
                  <el-table-column
                    label="生产厂家名称"
                    align="center"
                    prop="manufacturer"
                  >
                  </el-table-column>
                  <el-table-column
                    label="维修商名称"
                    align="center"
                    prop="maintenance"
                  >
                  </el-table-column>
                  <el-table-column
                    label="安装位置"
                    align="center"
                    prop="InstallationAreaName"
                  >
                  </el-table-column>

                  <!-- <el-table-column label="购置价格" align="center" prop="purchase_price">
        </el-table-column> -->
                  <el-table-column
                    label="购置日期"
                    align="center"
                    prop="purchase_date"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.purchase_date
                          ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                          : ''
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" align="center" prop="State">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.State == 0">停机</el-tag>
                      <el-tag type="success" v-if="scope.row.State == 1"
                        >开机</el-tag
                      >
                      <el-tag type="warning" v-if="scope.row.State == 2"
                        >故障</el-tag
                      >
                      <el-tag type="danger" v-if="scope.row.State == 3"
                        >报废</el-tag
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>

              <el-collapse-item title="2.计划信息" name="2">
                <el-form
                  :model="dataInfo.device_TaskPlan"
                  ref="form"
                  label-width="140px"
                  disabled
                >
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="保养计划名称" prop="Name">
                        <el-input
                          v-model="dataInfo.device_TaskPlan.Name"
                          placeholder="请输入保养计划名称"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item label="计划开始日期" prop="StartTime">
                        <el-date-picker
                          v-model="dataInfo.device_TaskPlan.StartTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="计划结束日期" prop="EndTime">
                        <el-date-picker
                          v-model="dataInfo.device_TaskPlan.EndTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="周期性" prop="Periodicity">
                        <el-radio-group
                          v-model="dataInfo.device_TaskPlan.Periodicity"
                        >
                          <el-radio :label="0">天</el-radio>
                          <el-radio :label="1">周</el-radio>
                          <el-radio :label="2">月</el-radio>
                          <el-radio :label="3">年</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="间隔时长" prop="PeriodicityValue">
                        <el-input-number
                          v-model="dataInfo.device_TaskPlan.PeriodicityValue"
                          placeholder="请输入间隔时长"
                          controls-position="right"
                          style="width: 100%"
                          :step="1"
                          :precision="0"
                          :min="1"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="描述" prop="Remarks">
                    <div
                      v-html="dataInfo.device_TaskPlan.Remarks"
                      style="
                        width: 100%;
                        height: 600px;
                        overflow: auto;
                        border: 1px solid #e2e2e2;
                        padding: 10px;
                        background-color: #f5f7fa;
                      "
                    ></div>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </el-drawer>
    <WorkOrderList ref="WorkOrderList"></WorkOrderList>
  </div>
</template>
<script>
import moment from 'moment'
import WorkOrderList from './WorkOrderList'
export default {
  data() {
    return {
      moment,
      title: '',
      loading: false,
      DevData: [],
      drawer: false,
      //生成按钮 0未生成，1生成中，2暂停，3完成
      State: 0,
      activeName: '1',
      row: {},
      dataInfo: {
        device_TaskPlan: {},
      },
      rightloading: false,
      collapseNames: ['0', '1', '2', '3'],
      DeviceName: '',
    }
  },
  props: {},
  components: { WorkOrderList },
  methods: {
    handleSearch() {
      this.getInfo()
    },
    suspend() {
      this.State = 2 // 设置生成状态为暂停
      this.$notify.success('暂停成功，后续设备将不在生成')
    },
    openList(row) {
      this.$refs.WorkOrderList.openList('巡检生成详情', row)
    },
    async startExecution() {
      let loa = this.DevData.every((item) => item.loading === false)
      console.log(loa, 'loa')
      if (!loa) {
        return this.$notify.error('请等待当前设备生成完成后再操作')
      }
      this.State = 1 // 设置生成状态为生成中
      for (let i = 0; i < this.DevData.length; i++) {
        const item = this.DevData[i]
        if (item.TaskPlanDetailStatus == 0) {
          console.log(this.State, 'this.Statethis.Statethis.State')
          if (this.State == 2) {
            break
          }
          item.loading = true
          let numTime = setInterval(() => {
            if (!item.loading) {
              clearInterval(numTime)
              if (item.TaskPlanDetailStatus !== 1) {
                item.loadingNum = 0
              } else {
                item.loadingNum = 100
              }

              return
            }
            item.loadingmm++
            if (item.loadingNum == 95) {
              item.loadingNum = 95
              return
            }
            item.loadingNum = item.loadingNum + 5
          }, 1000)
          item.loadingmm = 0
          await this.$http
            .post(
              '/Base_DeviceTreeManage/Device_TaskPlan/SaveTaskPlanToWorkOrder?DetailId=' +
                item.DetailId,
              {}
            )
            .then((res) => {
              if (res.Success && res.Data) {
                this.$notify.success('生成成功')
                item.TaskPlanDetailStatus = 1
              } else {
                this.$notify.error(item.device_name + '生成失败')

                item.loadingmm = 0
              }
            })
          item.loading = false
          console.log(item, '111')
        }
      }
      this.State = 0
      //  for (const item of this.DevData) {
      //   console.log(item)
      //   if(item.TaskPlanDetailStatus==0){
      //     item.loading=true
      //   await setTimeout(()=>{
      //     console.log(item,';;;;;;;;;;')
      //     item.TaskPlanDetailStatus=1

      //    },2000)
      //    console.log(item.TaskPlanDetailStatusTaskPlanDetailStatus)
      //    item.loading=false
      //   }

      //  }
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.DevData = []
      this.State = 0
      this.title = title
      this.row = row
      this.DeviceName = ''
      if (row.Id) {
        this.getInfo()
        this.getdataInfo()
      }
    },
    getdataInfo() {
      this.rightloading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_TaskPlan/GetTheTaskPlanData', {
          id: this.row.Id,
        })
        .then((res) => {
          this.rightloading = false
          if (res.Success) {
            this.dataInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },

    getInfo() {
      this.loading = true
      this.$http
        .post(
          `/Base_DeviceTreeManage/Device_TaskPlan/GetTaskPlanDetailsDataList?TaskPlanId=${this.row.Id}&DeviceName=${this.DeviceName}`,
          {}
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            resJson.Data.forEach((item) => {
              this.$set(item, 'loading', false)
              this.$set(item, 'loadingmm', 0)
              if (item.TaskPlanDetailStatus == 1) {
                this.$set(item, 'loadingNum', 100)
              } else {
                this.$set(item, 'loadingNum', 0)
              }
            })
            this.DevData = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.State = 2
          this.drawer = false
          this.$emit('close')
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {
    numTo() {
      return this.DevData.filter((item) => {
        return item.TaskPlanDetailStatus == 1
      }).length
    },
    rowclassname() {
      return ({ row, index }) => {
        console.log(row, 'row')
        if (row.loading) {
          return 'is-loading'
        }
      }
    },
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 10px 20px;
}
.form-center {
  height: calc(100vh - 110px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .el-collapse-item__header {
  font-weight: bold;
  font-size: 18px;
}
::v-deep .is-loading {
  // background: url("loading-icon.svg") no-repeat center center;
}
/* 整行加载效果 */
::v-deep .el-table .is-loading {
  position: relative;
}

::v-deep .el-table .is-loading td {
  position: relative;
  overflow: hidden;
  background: #f5f2f2 !important;
  opacity: 0.5 !important;
}

::v-deep .el-table .is-loading::after {
  content: ''; /* 清空文字内容 */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 1099;
  pointer-events: none;
  background-image: url('../../../assets/loading.png');
  background-size: 30px 30px;
  background-position: center;
  background-repeat: no-repeat;

  /* 旋转动画 */
  animation: rotating 2s linear infinite;
}

/* 创建旋转动画 */
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

::v-deep .el-table .is-loading .cell {
  position: relative;
  z-index: 11;
}
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
</style>
